import React, { useState } from "react";
import Modal from "./Modal";
import Button from "./Button";
import Input from "./Input";
import ARoomAlbumPolicyFields, { AROOM_ALBUM_VISIBILITY } from "./ARoomAlbumPolicyFields";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

const ARoomAlbumPolicyModal = ({ album, isPrivateARoom = false, onClose, onSaved }) => {
  const { t } = useTranslation("common");
  const [name, setName] = useState(album.Name || "");
  const [policy, setPolicy] = useState({
    ContainsMinors: album.ContainsMinors === true,
    ARoomVisibility: Number(album.ARoomVisibility ?? AROOM_ALBUM_VISIBILITY.Public),
    ConsentConfirmed: album.ConsentConfirmed === true,
  });
  const [busy, setBusy] = useState(false);

  const save = async () => {
    if (!name.trim()) return toast.warning(t("aRoomAlbumPolicy.albumNameRequired"));
    setBusy(true);
    try {
      await onSaved({
        AlbumId: Number(album.Id),
        Name: name.trim(),
        ContainsMinors: policy.ContainsMinors,
        ARoomVisibility: policy.ContainsMinors ? AROOM_ALBUM_VISIBILITY.IndividuallyApproved : policy.ARoomVisibility,
        ConsentConfirmed: policy.ConsentConfirmed,
      });
      onClose();
    } finally { setBusy(false); }
  };


  return <Modal title={t("aRoomAlbumPolicy.settingsTitle")} onClose={onClose} busy={busy} maxWidth={560}
    footer={<><Button variant="secondary" onClick={onClose} disabled={busy}>{t("actions.cancel")}</Button><Button onClick={save} disabled={busy}>{t("aRoomAlbumPolicy.saveAlbum")}</Button></>}>
    <Input label={t("aRoomAlbumPolicy.albumName")} value={name} onChange={(e) => setName(e.target.value)} required />
    <ARoomAlbumPolicyFields value={policy} onChange={setPolicy} isPrivateARoom={isPrivateARoom} />
  </Modal>;
};
export default ARoomAlbumPolicyModal;
